import { SELECT_ELEMENT, UNSELECT_ELEMENT, UNSELECT_ALL, SELECT_ELEMENTS, ADD_FILTER, REMOVE_FILTER, RESET_FILTERS, ADD_FILTERS } from "../../../actions";
import { modelService } from '../../../../services/model';
import _ from 'lodash';

export default function (oldEnabledElements, newSelectedElements, action) {
  const unfilteredSelectedElements = newSelectedElements.filter(e => !e.filtered);
  switch (action.type) {
    case SELECT_ELEMENT:
    case SELECT_ELEMENTS:
    case UNSELECT_ELEMENT:
    case UNSELECT_ALL:
    case ADD_FILTER:
    case ADD_FILTERS:
    case REMOVE_FILTER:
    case RESET_FILTERS:
      return determineEnabledElements(unfilteredSelectedElements);
    default:
      return oldEnabledElements;
  }
}


function determineEnabledElements(selectedElements) {
  if (selectedElements.length === 0) {
    return modelService.getAllComponents().map(c => c.id);
  } else {
    const selectedElementIds = selectedElements.map(e => e.id); 
    const compatibleComponents = selectedElementIds.reduce((list, id) => [...list, ...modelService.getCompatibleComponents(id).map(c => c.id)], []);

    return _.uniq([...selectedElementIds, ...compatibleComponents]);
  }
}






// WEBPACK FOOTER //
// ./src/redux/reducers/elements/enable/index.js